import BaseForm from '../base';
import { LatLongColumnsComponent, TwoColumnsComponent, HostComponent } from '../components';
export class SpeakersForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
            new TwoColumnsComponent({ key: 'localNetwork' }, {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            }, {
                label: 'Local Port',
                key: 'httpAlt',
                type: 'number',
            }),
            new HostComponent({
                key: 'externalNetwork',
                componentOverrides: {
                    ip: {
                        label: 'External Address',
                        key: 'externalIp',
                    },
                    port: {
                        label: 'External Port',
                        key: 'externalPort',
                    }
                }
            }),
            new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }), {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
        ];
    }
}
